import { useEffect, useRef } from 'react';
import { useStateInRef } from 'seagull';
import { handleRequest } from '~/infra/utils';
export const REGREET_DELAY_MS = 400;
export const useGreetingRefresh = (param)=>{
    let { greetingScopeKey, regreetDelayMs, canRegreet, createConversation, adoptGreeting, isSupersededSince, currentToken } = param;
    const greetedScopeKeyRef = useRef(null);
    const regreetEpochRef = useRef(0);
    const getScopeKey = useStateInRef(greetingScopeKey);
    const getCanRegreet = useStateInRef(canRegreet);
    const getRegreetNow = useStateInRef(regreetNow);
    // WHY the key itself is the dependency, not a derived staleness flag: such a flag stays true across a second change mid-flight, so the effect would never run again.
    useEffect(()=>{
        const greetedScopeKey = greetedScopeKeyRef.current;
        if (greetedScopeKey != null && greetedScopeKey !== greetingScopeKey && canRegreet) {
            const timer = setTimeout(()=>void getRegreetNow()(), regreetDelayMs);
            return ()=>clearTimeout(timer);
        }
        return undefined;
    }, [
        greetingScopeKey,
        canRegreet,
        regreetDelayMs
    ]);
    // WHY: the greeting is swapped only once its replacement has arrived — wiping first would leave an empty pane, and an error toast, for something the seller never asked for.
    async function regreetNow() {
        const regreetAtCall = ++regreetEpochRef.current;
        const tokenAtCall = currentToken();
        const keyAtCall = getScopeKey();
        const created = await handleRequest(createConversation());
        const isCurrent = regreetAtCall === regreetEpochRef.current && !isSupersededSince(tokenAtCall);
        // WHY re-checked after the round-trip: a turn started meanwhile would lose its message to the swap and keep streaming into the abandoned conversation.
        if (!created.success || !isCurrent || !getCanRegreet()) return;
        greetedScopeKeyRef.current = keyAtCall;
        adoptGreeting(created.data.conversationId, created.data.message);
    }
    return {
        markGreeted: (scopeKey)=>{
            greetedScopeKeyRef.current = scopeKey;
        },
        forgetGreeting: ()=>{
            greetedScopeKeyRef.current = null;
        }
    };
};
